<div class="container">
    <div
        *ngIf="inEditMode"
        class="delete-icon-container"
        (click)="removeItem(); $event.stopPropagation()"
    >
        <mat-icon svgIcon="delete" class="delete-icon" />
    </div>
    <div class="left-container">
        <div data-cy="custom-meter-graph-title" class="channel-title">
            {{ channel.opsData.name }}
        </div>
        <div
            data-cy="custom-meter-graph-status"
            class="channel-status"
            [style.color]="getBarGraphColor()"
        >
            {{ statusString | translate }}
        </div>
        <div class="channel-data">
            <span
                data-cy="custom-meter-graph-value"
                [style.color]="getBarGraphColor()"
                >{{ channelValue ? channelValue : 0 }}</span
            >
            <span data-cy="custom-meter-graph-unit" class="channel-unit">{{
                channel.opsData.measurementUnit
            }}</span>
        </div>
    </div>
    <div class="right-container">
        <div class="number-container">
            <div data-cy="custom-meter-graph-max-range" class="top-number">
                {{ getScaledValue(channel.fcuData.measurableRange.max) }}
            </div>
            <div data-cy="custom-meter-graph-min-range" class="bottom-number">
                {{ getScaledValue(channel.fcuData.measurableRange.min) }}
            </div>
        </div>

        <div class="graph-container">
            <div
                class="graph"
                [style.height]="calculateHeight() + '%'"
                [style.backgroundColor]="getBarGraphColor()"
            ></div>
        </div>
    </div>
</div>
